import { useCallback } from 'react'
import { Box } from '@mui/material'
import NewWeddingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import InputCustom from '../../../components/atoms/input/InputCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'
import SelectCustom from '../../../components/atoms/select/SelectCustom'
import { EMAIL_RE, WEDDING_ROLES } from '../../../util/constants'
import CheckBoxCustom from '../../../components/atoms/checkbox/CheckBox'

function Partner({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
	index = 1,
}) {
	const partnerKey = index === 1 ? 'partner1' : 'partner2'
	const partnerData = weddingData[partnerKey]

	const updatePartnerData = useCallback(
		(updates) => {
			setWeddingData((prev) => ({
				...prev,
				[partnerKey]: {
					...prev[partnerKey],
					...updates,
				},
			}))
		},
		[partnerKey, setWeddingData]
	)

	const handleNextClick = () => {
		if (!partnerData.partnerName?.trim())
			return toastHelper('Please enter a partner name', 'error')

		// if (!partnerData.designation)
		// 	return toastHelper('Please select a designation', 'error')

		if (partnerData.email && !EMAIL_RE.test(partnerData.email?.trim()))
			return toastHelper('Please enter a valid email address', 'error')

		handleNext()
	}

	return (
		<NewWeddingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Partner {index}</h2>
					<div style={{ width: '100%', marginTop: '40px' }}>
						<div className={styles.modalContainer}>
							<Box className={styles.formInputs}>
								<InputCustom
									type="text"
									name="partnerName"
									placeholder="Partner Name"
									value={partnerData.partnerName || ''}
									onChange={(e) =>
										updatePartnerData({
											partnerName: e.target.value,
										})
									}
									required={true}
									data_cy={`partner${index}Name`}
								/>

								{/* <SelectCustom
									label="Select your designation"
									options={WEDDING_ROLES}
									defaultValue={partnerData.designation}
									renderValueAsLabel={true}
									setDataFunction={(e) =>
										updatePartnerData({
											designation: e.value,
										})
									}
								/> */}

								<InputCustom
									type="email"
									placeholder="Email Address (optional)"
									name="email"
									value={partnerData.email || ''}
									onChange={(e) => {
										const email = e.target.value.trim()

										updatePartnerData({
											email: email,
										})
									}}
									data_cy={`partner${index}Email`}
								/>

								{/* <CheckBoxCustom
									checked={partnerData.sentInvite || false}
									onChange={() =>
										updatePartnerData({
											sentInvite: !partnerData.sentInvite,
										})
									}
									label="Send invitation email?"
									lineColor="#7ca6bd"
									labelColor="#7ca6bd"
								/> */}
							</Box>
						</div>
					</div>
				</div>

				<ButtonCustom size="lg" onClick={handleNextClick}>
					Next
				</ButtonCustom>

				<div className={styles.buttonContainer}>
					<Stepper activeStep={index} />
				</div>
			</div>
		</NewWeddingModal>
	)
}

export default Partner
